enum ActionTypes {
  APPLY_SEARCH = 'app/AllBrands/APPLY_SEARCH',
  ALL_BRANDS_REQUEST = 'app/AllBrands/ALL_BRANDS_REQUEST',
  ALL_BRANDS_SUCCESS = 'app/AllBrands/ALL_BRANDS_SUCCESS',
  ALL_BRANDS_FAILURE = 'app/AllBrands/ALL_BRANDS_FAILURE',
  FETCH_MORE_BRANDS = 'app/AllBrands/FETCH_MORE_BRANDS',
}

export default ActionTypes;
